/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import usePrevious from 'hooks/usePrevious';

import { Modal, Box } from '@mui/material';

import injectSheet from 'react-jss';
import FinalsStyles from './Finals_Styles';

import Team from './Team';
import Gauge from './Gauge';
import TeamStats from './TeamStats';

import { getPick, getTeamsFromPicks, getMatchupFromPicks } from '../../../redux/features/picks/picks';
import { setPick } from '../../../redux/features/picks/picksSlice';

const styles = FinalsStyles;

const Finals = ({
  classes,
  teamz,
  id,
  placeholders,
  roundName,
  reverse,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();

  const teams = useSelector((state) => getTeamsFromPicks(state, teamz));
  const pick = useSelector((state) => getPick(state, id));
  const matchup = useSelector((state) => getMatchupFromPicks(state, teamz));

  const handlePick = (_pick, teamId) => {
    dispatch(setPick({ ..._pick, teamId }));
  };

  const clearPick = (_pick) => {
    dispatch(setPick({ ..._pick, teamId: null }));
  };

  const makePick = (_pick, teamId) => {
    dispatch(setPick({ ..._pick, teamId }));
  };

  const previousProps = usePrevious({ teams, pick });

  useEffect(() => {
    if (previousProps && pick.teamId) {
      if (previousProps.pick.teamId && !teams.map((team) => team.id).includes(previousProps.pick.teamId)) { // eslint-disable-line max-len
        clearPick(pick);
      }
    }
  });

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setIsOpen(false);
  };

  const handleDialogPick = (_pick, teamId) => () => {
    makePick(_pick, teamId);
    handleClose();
  };

  const handleOpen = (event) => {
    const nodes = [].slice.call(document.querySelectorAll("[class^='teamradio']"));
    if (!nodes.some((node) => event.target.contains(node)) && teams[0].id && teams[1].id) {
      setIsOpen(true);
    }
  };

  return (
    <div className={classes.finals}>

      <div className={classes.roundname}>{roundName}</div>
      <div style={{ minWidth: '125px', textAlign: 'center' }}>
        <img src={`assets/images/${roundName === 'Final' ? 'world-cup-icon.png' : 'world-cup-third-place.svg'}`} style={{ width: `${roundName === 'Final' ? '65px' : '35px'}` }} alt="world cup icon" />
      </div>
      <div className={classes.match} onClick={handleOpen}>
        <Team
          team={teams[0]}
          pick={pick}
          color="#62AD1D"
          placeholder={placeholders[0]}
          onPick={handlePick}
          // justifyflexcontent="flex-end"
          radio="16px"
        />
        <Gauge
          matchup={matchup}
          gaugew="auto"
          tick="50%"
          reverse={reverse}
          teamA={teams[0].name}
          teamB={teams[1].name}
          style={{ minWidth: '40px' }}
        />

        <Team
          team={teams[1]}
          pick={pick}
          color="#F9981D"
          placeholder={placeholders[1]}
          onPick={handlePick}
          reverse
          // justifyflexcontent="flex-end"
          radio="16px"
        />
      </div>
      {/* Modal */}
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="Game details"
        aria-describedby="Game details"
        BackdropProps={{
          style: { backgroundColor: 'rgba(0,0,0,0.85)' },
        }}
      >
        <Box className={classes.modalContainer}>

          <div className={classes.luidialogbody}>
            <div className={classes.closerow}>
              <span className={classes.close} onClick={handleClose}>
                <img className={classes.img_close} src="assets/images/close.svg" alt="close" />
              </span>
            </div>
            <div className={classes.dialogbody}>
              {!!matchup && (
              <div className={classes.intro}>
                <div className={classes.introtitle}>
                  <div className={classes.bold}>
                    {matchup.chances[0] > matchup.chances[1]
                      ? teams[0].name : teams[1].name }
                  </div>
                  <div>is more likely to win</div>
                </div>
              </div>
              )}
              <div className={classes.teamsheader}>
                <div className={classes.team}>
                  <div
                    className={classes.flag}
                    onClick={handleDialogPick(pick, teams[0].id || null)}
                  >
                    <img className={classes.img} src={`assets/images/flags/${teams[0].id}.svg`} alt={teams[0].name} />
                  </div>
                  <div className={classes.teamname}>
                    {teams[0].name}
                  </div>
                  <div className={classes.chances}>
                    <div className={classes.ball_left} />
                    {!!matchup && ((100 * (matchup && matchup.chances[0])).toPrecision(2))}
                    %
                  </div>
                </div>
                <div className={classes.team}>
                  <div
                    className={classes.flag}
                    onClick={handleDialogPick(pick, teams[1].id || null)}
                  >
                    <img className={classes.img} src={`assets/images/flags/${teams[1].id}.svg`} alt={teams[1].name} />
                  </div>
                  <div className={classes.teamname}>
                    {teams[1].name}
                  </div>
                  <div className={classes.chances}>
                    {!!matchup && ((100 * (matchup && matchup.chances[1])).toPrecision(2))}
                    %
                    <div className={classes.ball_right} />
                  </div>
                </div>
              </div>
              <Gauge
                matchup={matchup}
                teamA={teams[0].name}
                teamB={teams[1].name}
                gaugew="100%"
                tick="50%"
                gaugeh="12px"
                style={{ marginLeft: '0' }}
                tickcolor="#333"
                tickborder="1px solid #fff"
              />
              <div className={classes.teamStats}>
                <div className={classes.left}>
                  {!!teams[0].id && <TeamStats team={teams[0]} reverse />}
                </div>
                <div className={classes.legend}>
                  <div>FIFA Ranking</div>
                  <div>Elo Ranking</div>
                  <div className={classes.recent}>
                    Recent fixtures
                    <div className={classes.smalltext}>
                      (2021-2022)
                    </div>
                  </div>
                  <div>Games Played</div>
                  <div>Games Won</div>
                  <div>Games Drawn</div>
                  <div>Games Lost</div>
                  <div className={classes.separator} />
                  <div>Goals Scored</div>
                  <div>Goals Against</div>

                </div>
                <div className={classes.right}>
                  {!!teams[1].id && <TeamStats team={teams[1]} />}
                </div>
              </div>
            </div>
          </div>

          <div className={classes.dialogfooter}>
            <div className={classes.dialogdesc}>
              Check each team
              {'\''}
              s stats and pick a winner
            </div>
            <div className={classes.dialogControls}>
              <div
                className={classes.button1}
                onClick={handleDialogPick(pick, teams[0].id || null)}
              >
                <div className={classes.ball1} />
                Choose
                {' '}
                {teams[0].name}
              </div>
              <div
                className={classes.button2}
                onClick={handleDialogPick(pick, teams[1].id || null)}
              >
                <div className={classes.ball2} />
                Choose
                {' '}
                {teams[1].name}
              </div>
            </div>
          </div>

        </Box>
      </Modal>

    </div>

  );
};

Finals.propTypes = {
  classes: PropTypes.object.isRequired,
  teamz: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  placeholders: PropTypes.array.isRequired,
  roundName: PropTypes.string.isRequired,
  reverse: PropTypes.bool,
};

Finals.defaultProps = {
  reverse: false,
};

export default injectSheet(styles)(Finals);
